import { z } from "zod";

export const minLengthErrorMessage = "Password must be at least 8 characters long";
export const maxLengthErrorMessage = "Password must be at most 20 characters long";
export const uppercaseErrorMessage = "Password must contain at least one uppercase letter";
export const lowercaseErrorMessage = "Password must contain at least one lowercase letter";
export const numberErrorMessage = "Password must contain at least one number";
export const specialCharacterErrorMessage = "Password must contain at least one special character";
export const passwordMismatchErrorMessage = "Passwords do not match";

export const passwordRule = z
  .string()
  .min(8, { message: minLengthErrorMessage })
  .max(20, { message: maxLengthErrorMessage })
  .refine((password) => /[A-Z]/.test(password), {
    message: uppercaseErrorMessage,
  })
  .refine((password) => /[a-z]/.test(password), {
    message: lowercaseErrorMessage,
  })
  .refine((password) => /[0-9]/.test(password), { message: numberErrorMessage })
  .refine((password) => /[!@#$%^&*]/.test(password), {
    message: specialCharacterErrorMessage,
  });

export const passwordConfirmationSchema = z
  .object({
    password: passwordRule,
    confirmPassword: z.string().min(8, minLengthErrorMessage),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: passwordMismatchErrorMessage,
    path: ["confirmPassword"],
  });
